export const SHUFFLE = 'SHUFFLE';
export const FINDE_EMPTY_AND_CLICKBLES = 'FINDE_EMPTY_AND_CLICKBLES';
export const MOVE_UP = 'MOVE_UP';
export const MOVE_RIGHT = 'MOVE_RIGHT';
export const MOVE_DOWN = 'MOVE_DOWN';
export const MOVE_LEFT = 'MOVE_LEFT';
export const WIN = 'WIN';
